import axios from "axios";
import { Base_URL } from "../url";

export const fetchTaxCategories = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TaxCategory/GetAllTaxCategories`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching tax categories!";
  }
};

export const downloadTaxCategoriesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/TaxCategory/DownloadTaxCategoriesExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading tax categories data!";
  }
};